package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.CostSourceTypeDto
import com.evoapps.evoshift.domain.model.CostSourceType

class CostSourceTypeMapper {

    fun toDomain(dto: CostSourceTypeDto): CostSourceType {
        return when (dto) {
            CostSourceTypeDto.GENERATED_FROM_RULE -> CostSourceType.GENERATED_FROM_RULE
            CostSourceTypeDto.MANUAL_ONE_OFF -> CostSourceType.MANUAL_ONE_OFF
            CostSourceTypeDto.ALLOCATED_FROM_OWNER -> CostSourceType.ALLOCATED_FROM_OWNER
        }
    }

    fun toDto(domain: CostSourceType): CostSourceTypeDto {
        return when (domain) {
            CostSourceType.GENERATED_FROM_RULE -> CostSourceTypeDto.GENERATED_FROM_RULE
            CostSourceType.MANUAL_ONE_OFF -> CostSourceTypeDto.MANUAL_ONE_OFF
            CostSourceType.ALLOCATED_FROM_OWNER -> CostSourceTypeDto.ALLOCATED_FROM_OWNER
        }
    }
}
